<div class="-date">{{ date }}</div>
<div class="-content">
  <ng-content></ng-content>
</div>